import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  paper: {
    padding: theme.spacing(2),
  },
  form: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  fileInput: {
    width: "97%",
    margin: "10px 0",
  },
  buttonSubmit: {
    marginBottom: 10,
  },
  textField: {
    margin: 5,
  },
  Textarea: {
    border: "none",
    outline: "none",
    margin: 5,
    borderBottom: "2px solid balck",
    width: "100%",
    height: "48px",
  },
  divider: {
    width: "90%",
    position: "relative",
    left: "-13%",
    marginTop: "-5px",
    height: "1px",
    backgroundColor: "#000",
  },
  [theme.breakpoints.down("sm")]: {
    divider: {
      left: "-16%",
    },
  },
}));
